import * as React from 'react';
import {
	Box,
	LinearProgress,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from '@mui/material';
import { ICurrencyRateList } from '../../../types';
import { formatDateToShowUser } from '../../../../common/helpers';

export type CurrencyRatesTableProps = {
	rows: ICurrencyRateList[];
	loading: boolean;
};

export const CurrencyRatesTable = ({ rows, loading }: CurrencyRatesTableProps): JSX.Element => {
	const isEmpty = !loading && rows.length === 0;

	return (
		<Paper elevation={1}>
			<Box p={2} pb={0} display="flex" alignItems="center" justifyContent="space-between">
				<Typography variant="h6">Últimas tasas de cambio</Typography>
			</Box>
			{loading && <LinearProgress />}
			<TableContainer>
				<Table size="small" aria-label="currency-rates-table">
					<TableHead>
						<TableRow>
							<TableCell>Fecha</TableCell>
							<TableCell>Moneda</TableCell>
							<TableCell align="right">Base rate</TableCell>
							<TableCell align="right">Spread</TableCell>
							<TableCell align="right">Effective rate</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{rows.map((r) => (
							<TableRow
								key={`${r.id}-${r.date}-${r.coinCode}`}
								sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
							>
								<TableCell>{formatDateToShowUser(r.date)}</TableCell>
								<TableCell>
									<Typography component="span" fontWeight={600}>
										{r.coinCode}
									</Typography>
								</TableCell>
								<TableCell align="right">{r.baseRate}</TableCell>
								<TableCell align="right">{r.spread}</TableCell>
								<TableCell align="right">
									<Typography component="span" fontWeight={600}>
										{r.effectiveRate}
									</Typography>
								</TableCell>
							</TableRow>
						))}
						{isEmpty && (
							<TableRow>
								<TableCell colSpan={5}>
									<Box p={2} textAlign="center" color="text.secondary">
										No hay tasas de cambio para mostrar
									</Box>
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</Paper>
	);
};
